import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import { UserInterfaceStylePluginInterface } from './definitions';
import { CAPACITOR_USER_INTERFACE_STYLE_PLUGIN } from '../pluginConstants';

const UserInterfaceStylePluginRaw = registerPlugin<UserInterfaceStylePluginInterface>(
    CAPACITOR_USER_INTERFACE_STYLE_PLUGIN,
);
// Wrapped to ensure rejected bridge calls retain a call-site stack trace.
const UserInterfaceStylePlugin = withBridgedStackTrace(
    UserInterfaceStylePluginRaw,
    CAPACITOR_USER_INTERFACE_STYLE_PLUGIN,
);

export * from './definitions';
export { UserInterfaceStylePlugin };
